import Papa from 'papaparse';
function to_csv(workbook,type) {
    let result = [];
    workbook.SheetNames.forEach(function (sheetName) {
        let csv = [];
        if(type == 'xls'){
           csv = XLS.utils.sheet_to_csv(workbook.Sheets[sheetName]);
        } else if (type == 'xlsx'){
           csv = XLSX.utils.sheet_to_csv(workbook.Sheets[sheetName]);
        }
        if (csv.length > 0) {
            result.push(csv);
        }
    });
    return result.join("\n");
}

window.import_file_callback = function(){
    let add_list, file, reader, csv_file, xls_file;
    add_list = $(this);
    file = $(this)[0].files[0];
    let valid_file = false;
    let date_regex = /^([0-9]{4})-([0-1][0-9])-([0-3][0-9])$/;
    let email_regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]+$/;
    let number_regex = /^[0-9]*$/;
    if (file) {
        reader = new FileReader();
        let file_name_parts = file.name.split(".");
        if (file_name_parts[file_name_parts.length - 1] == "csv") {
            reader.readAsText(file);
            csv_file = true;
            xls_file = false;
            valid_file = true;
        } else {
            csv_file = false;
            reader.readAsArrayBuffer(file);
            if (file_name_parts[file_name_parts.length - 1] == "xlsx") {
                xls_file = false;
                valid_file = true;
            } else {
                if (file_name_parts[file_name_parts.length - 1] == "xls"){
                    xls_file = true;
                    valid_file = true;
                }
            }
        }
        if (valid_file) {
            let file_name = file.name;
            reader.onload = function (ee) {
                let imported_data = [];
                if (csv_file === true) {
                    let csv_rows = Papa.parse(ee.target.result, {}).data;
                    for(let i = 0; i < csv_rows.length; i = i + 1){
                      let item = csv_rows[i];
                      if(item.length > 1){
                        if (i === 0)
                        {
                          item[2] = item[2].trim();
                          if(!email_regex.test(item[2]))
                          {
                            if (item[0] !== ("First name") ||
                                item[1] !== ("Last name") ||
                                item[2] !== ("Email") ||
                                item[3] !== ("First day (YYYY-MM-DD)") ||
                                (item[4] !== ("Deactivation date (YYYY-MM-DD or amount of days)") &&
                                item[4] !== ("Last day (YYYY-MM-DD or amount of days)")) ||
                                item[5] !== ("Group ids") ||
                                item[6] !== ("Blue tags (Country)") ||
                                item[7] !== ("Green tags (Office)") ||
                                item[8] !== ("Purple tags (Role)")
                               )
                            {
                              alert("Please make sure headers are same as mentioned in sample file.");
                              return;
                            }
                            else 
                            {
                              if (!!item[9] && item[9] !== ("Manager emails"))
                              {
                                alert("Please make sure headers are same as mentioned in sample file.");
                                return;
                              }
                              else
                              {
                                continue;
                              }
                            }
                          }
                        }
                        if(item.length < 3){
                            $("#import_users").replaceWith($("#import_users").val('').clone(true));
                            alert("Some records and invalid please check your file.");
                            return;
                        } else {
                            if(!!!item[0] || !!!item[1] || !!!item[2]){
                              $("#import_users").replaceWith($("#import_users").val('').clone(true));
                              alert("First name, last name or email seems to be missing for some users in selected file.");
                              return;
                            } else {
                              item[2] = item[2].trim();
                              if(!email_regex.test(item[2])){
                                $("#import_users").replaceWith($("#import_users").val('').clone(true));
                                alert("Email "+item[2]+" is not of correct format for a user in selected file.");
                                return;
                              }
                            }

                        }
                        let first_day = item[3];
                        let last_day = item[4];
                        if(!!first_day){
                          if(!date_regex.test(first_day)){
                            $("#import_users").replaceWith($("#import_users").val('').clone(true));
                            alert("First day for the user "+item[2]+" in the selected file should be in format YYYY-MM-DD.");
                            return;
                          }
                        }

                        if(!!last_day){
                          if(!date_regex.test(last_day) && !number_regex.test(last_day)){
                            $("#import_users").replaceWith($("#import_users").val('').clone(true));
                            alert("Last day for the user "+item[2]+" in the selected file should be an integer or a date in format YYYY-MM-DD.");
                            return;
                          }
                        }
                        imported_data.push(item);
                      }
                    }

                } else if (xls_file === true) {
                    let binary = "";
                    let bytes = new Uint8Array(ee.target.result);
                    let length = bytes.byteLength;
                    for (let i = 0; i < length; i++) {
                      binary += String.fromCharCode(bytes[i]);
                    }
                    let temp1 = XLS.parse_xlscfb(XLS.CFB.read(binary, {type: 'binary'}));
                    let temp2 = to_csv(temp1,'xlsx').split('\n');
                    for (let i = 0; i < temp2.length; i++) {
                       let tmp1 = temp2[i].split(',');
                       if(tmp1.length > 1){
                         if (i === 0)
                         {
                           tmp1[2] = tmp1[2].trim();
                           if(!email_regex.test(tmp1[2]))
                           {
                             if (tmp1[0] !== ("First name") ||
                                 tmp1[1] !== ("Last name") ||
                                 tmp1[2] !== ("Email") ||
                                 tmp1[3] !== ("First day (YYYY-MM-DD)") ||
                                 (tmp1[4] !== ("Deactivation date (YYYY-MM-DD or amount of days)") &&
                                 tmp1[4] !== ("Last day (YYYY-MM-DD or amount of days)")) ||
                                 tmp1[5] !== ("Group ids") ||
                                 tmp1[6] !== ("Blue tags (Country)") ||
                                 tmp1[7] !== ("Green tags (Office)") ||
                                 tmp1[8] !== ("Purple tags (Role)")
                                )
                             {
                               alert("Please make sure headers are same as mentioned in sample file.");
                               return;
                             }
                             else
                             {
                               if (!!tmp1[9] && tmp1[9] !== ("Manager emails"))
                               {
                                 alert("Please make sure headers are same as mentioned in sample file.");
                                 return;
                               }
                               else
                               {
                                 continue;
                               }
                             }
                           }
                         }
                         if(tmp1.length < 3){
                            $("#import_users").replaceWith($("#import_users").val('').clone(true));
                            alert("Some records and invalid please check your file.");
                            return;
                         } else {
                             if(!!!tmp1[0] || !!!tmp1[1] || !!!tmp1[2]){
                               $("#import_users").replaceWith($("#import_users").val('').clone(true));
                               alert("First name, last_name or email seems to be missing for some records and in selected file.");
                               return;
                             } else {
                               tmp1[2] = tmp1[2].trim();
                               if(!email_regex.test(tmp1[2])){
                                 $("#import_users").replaceWith($("#import_users").val('').clone(true));
                                 alert("Email "+tmp1[2]+" is not of correct format for a user in selected file.");
                                 return;
                               }
                             }
                         }

                         let first_day = tmp1[3];
                         let last_day = tmp1[4];

                         if(!!first_day){
                           if(!date_regex.test(first_day)){
                             $("#import_users").replaceWith($("#import_users").val('').clone(true));
                             alert("First day for the user "+tmp1[2]+" in the selected file should be in format YYYY-MM-DD.");
                             return;
                           }
                         }

                         if(!!last_day){
                           if(!date_regex.test(last_day) && !number_regex.test(last_day)){
                             $("#import_users").replaceWith($("#import_users").val('').clone(true));
                             alert("Last day for the user "+tmp1[2]+" in the selected file should be an integer or a date in format YYYY-MM-DD.");
                             return;
                           }
                         }
                         let tmp2 = tmp1.splice(10, tmp1.length - 1);
                         tmp2 = tmp2.toString().replace(/"/g, '');
                         tmp1.push(tmp2);
                         imported_data.push(tmp1);
                     }
                    }
                } else {
                    const binary = String.fromCharCode.apply(null, new Uint8Array(ee.target.result));
                    let temp1 = XLSX.read(btoa(binary), {type: 'base64'});
                    let temp2 = to_csv(temp1,'xlsx').split('\n');
                    for (let i = 0; i < temp2.length; i++) {
                      let tmp1 = temp2[i].split(',');
                      if(tmp1.length > 1){
                        if (i === 0)
                        {
                          tmp1[2] = tmp1[2].trim();
                          if(!email_regex.test(tmp1[2]))
                          {
                            if (tmp1[0] !== ("First name") ||
                                tmp1[1] !== ("Last name") ||
                                tmp1[2] !== ("Email") ||
                                tmp1[3] !== ("First day (YYYY-MM-DD)") ||
                                (tmp1[4] !== ("Deactivation date (YYYY-MM-DD or amount of days)") &&
                                tmp1[4] !== ("Last day (YYYY-MM-DD or amount of days)")) ||
                                tmp1[5] !== ("Group ids") ||
                                tmp1[6] !== ("Blue tags (Country)") ||
                                tmp1[7] !== ("Green tags (Office)") ||
                                tmp1[8] !== ("Purple tags (Role)")
                               )
                            {
                              alert("Please make sure headers are same as mentioned in sample file.");
                              return;
                            }
                            else
                            {
                              if (!!tmp1[9] && tmp1[9] !== ("Manager emails"))
                              {
                                alert("Please make sure headers are same as mentioned in sample file.");
                                return;
                              }
                              else
                              {
                                continue;
                              }
                            }
                          }
                        }
                        if(tmp1.length < 3){
                            $("#import_users").replaceWith($("#import_users").val('').clone(true));
                            alert("Some records and invalid please check your file.");
                            return;
                        } else {
                            if(!!!tmp1[0] || !!!tmp1[1] || !!!tmp1[2]){
                              $("#import_users").replaceWith($("#import_users").val('').clone(true));
                              alert("First name, last_name or email seems to be missing for some records and in selected file.");
                              return;
                            } else {
                              tmp1[2] = tmp1[2].trim();
                              if(!email_regex.test(tmp1[2])){
                                $("#import_users").replaceWith($("#import_users").val('').clone(true));
                                alert("Email "+tmp1[2]+" is not of correct format for a user in selected file.");
                                return;
                              }
                            }
                        }

                        let first_day = tmp1[3];
                        let last_day = tmp1[4];

                        if(!!first_day){
                          if(!date_regex.test(first_day)){
                            $("#import_users").replaceWith($("#import_users").val('').clone(true));
                            alert("First day for the user "+tmp1[2]+" in the selected file should be in format YYYY-MM-DD.");
                            return;
                          }
                        }

                        if(!!last_day){
                          if(!date_regex.test(last_day) && !number_regex.test(last_day)){
                            $("#import_users").replaceWith($("#import_users").val('').clone(true));
                            alert("Last day for the user "+tmp1[2]+" in the selected file should be an integer or a date in format YYYY-MM-DD.");
                            return;
                          }
                        }

                        let tmp2 = tmp1.splice(10, tmp1.length - 1);
                        tmp2 = tmp2.toString().replace(/"/g, '');
                        tmp1.push(tmp2);
                        imported_data.push(tmp1);
                      }
                    }
                }
                $("#import_users_file").attr('placeholder', file_name);
                $('#imported_users').val(JSON.stringify(imported_data));
            };
        } else {
            $("#import_users").replaceWith($("#import_users").val('').clone(true));
            alert("Selected file is invalid. Only CSV, XLSX and XLS files are allowed");
        }
    }
}
